import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    textContainer: {
        width: 80,
        justifyContent: 'center',
        alignItems: 'center',
    },
    textStyle: {
        width: 80,
    },
    labelStyleLeft: {
        textAlign: 'center',
        width: 100,
    },
    textStyleCenter: {
        textAlign: 'center',
        width: 80,
    },
    textStyleRight: {
        width: 80,
    },
    labelStyleRight: {
        textAlign: 'center',
        width: 100,
    },
    rightCellTextContainer: {
        alignItems: 'flex-end',
    },
    leftCellTextContainer: {
        alignItems: 'flex-start',
    },
});

export default styles;
